import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PrizesPage, type PrizesSearch } from '@/features/prizes';

const STATUSES = ['active', 'finished', 'ended', 'all'] as const;

export const Route = createFileRoute('/_auth/$orgId/marketing/prizes')({
  validateSearch: (search: Record<string, unknown>): PrizesSearch => ({
    status: STATUSES.find((status) => status === search.status),
    award: typeof search.award === 'string' && search.award.length > 0 && search.award.length <= 64 ? search.award : undefined,
  }),
  component: PrizesRoute,
});

function PrizesRoute() {
  const { orgId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: '/$orgId/marketing/prizes' });
  // Opening / closing a winner replaces the history entry; a filter change pushes one (Back undoes it).
  return (
    <PrizesPage
      orgId={orgId}
      search={search}
      onChangeSearch={(next) => void navigate({ search: next, replace: next.award !== search.award })}
    />
  );
}
